import * as React from 'react';
export function usePrevious(isActive) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = isActive;
    }, [isActive]);
    return ref.current;
}
//# sourceMappingURL=usePrevious.js.map